import { GeneralSettingsFields } from './GeneralSettingsFields'
import {
    selectProductGeneralSettings,
    selectSettingsState,
} from '../../../store/selectors/settingsSelectors'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { useEffect } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { fetchProductGeneralSettings } from '../../../store/async-thunks/settings/fetchProductGeneralSettings'
import Loader from '../../Loader/Loader'
import { FormattedMessage } from 'react-intl'

interface Props {
    guid: string
}

export const GeneralSettings = ({ guid }: Props) => {
    const dispatch = useAppDispatch()
    const { isLoading, error } = useAppSelector(selectSettingsState)
    const productGeneralSettings = useAppSelector(
        selectProductGeneralSettings(guid)
    )

    useEffect(() => {
        if (!productGeneralSettings) {
            dispatch(fetchProductGeneralSettings({ guid }))
        }
    }, [guid, dispatch])

    if (isLoading)
        return (
            <div className="vh-full d-flex justify-content-center">
                <Loader />
            </div>
        )

    if (error)
        return (
            <div className={`my-4 px-4 py-3 fs-5 error-in-frame`}>
                <FormattedMessage id={error} />
            </div>
        )

    return (
        <GeneralSettingsFields
            guid={guid}
            generalSettings={productGeneralSettings}
        />
    )
}
